'use client';

import {
  adminClient,
  emailOTPClient,
  inferAdditionalFields,
  organizationClient,
} from 'better-auth/client/plugins';
import { oauthProviderClient } from '@better-auth/oauth-provider/client';
import { createAuthClient } from 'better-auth/react';

import env from './env/client';
import { ac, roles } from './permissions';
import type auth from './server';

const authClient = createAuthClient({
  baseURL: env.NEXT_PUBLIC_APP_URL,
  plugins: [
    inferAdditionalFields<typeof auth>(),
    adminClient({
      ac,
      roles,
    }),
    organizationClient({ ac, roles }),
    emailOTPClient(),
    oauthProviderClient(),
  ],
});

export const {
  admin,
  emailOtp,
  getSession,
  oauth2,
  organization,
  revokeOtherSessions,
  sendVerificationEmail,
  signIn,
  signOut,
  signUp,
  updateUser,
  useListOrganizations,
} = authClient;
